function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.number.to-precision.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import { ErrorMessages, Keys } from "../Common/Constants";
import { GetDegreeOptionsByEducationLevel } from "./MapTools";
import { SCORE_LIMITS } from "../Common/StandardizedTests/consts";
import { SCORE_LIMITS as SCORE_LIMITS_ENGLISH_TEST, ENGLISH_EXAM_TYPE_VALUES } from "../Common/EnglishTests/consts";
var isRegionValid = function isRegionValid(value, regions) {
  return (regions === null || regions === void 0 ? void 0 : regions.length) !== 0 && (regions === null || regions === void 0 ? void 0 : regions.find(function (region) {
    return region.name === value;
  }));
};
export var isCountryFieldValid = function isCountryFieldValid(value, regions) {
  var keyName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var validationResult = [true, ''];
  if (value === null || value === undefined || value === '') {
    validationResult = [false, keyName && keyName === Keys.Application.educationCountry ? ErrorMessages.SELECT_EDUCATION_COUNTRY : ErrorMessages.REQUIRED_FIELD];
  } else if (!isRegionValid(value, regions)) {
    validationResult = [false, ErrorMessages.SELECT_VALID_COUNTRY];
  }
  return validationResult;
};
export var isProvinceFieldValid = function isProvinceFieldValid(value, regions) {
  var validationResult = [true, ''];
  if (value === null || value === undefined || value === '') {
    validationResult = [false, ErrorMessages.REQUIRED_FIELD];
  } else if (!isRegionValid(value, regions)) {
    validationResult = [false, ErrorMessages.SELECT_VALID_STATE];
  }
  return validationResult;
};
export var isVisaFieldValid = function isVisaFieldValid(value) {
  var validationResult = [true, ''];
  if (!value || Object.keys(value).every(function (e) {
    return !value[e];
  })) {
    validationResult = [false, ErrorMessages.REQUIRED_QUESTION];
  }
  return validationResult;
};
export var isEducationLevelFieldValid = function isEducationLevelFieldValid(value, educationLevels) {
  var validationResult = [true, ''];
  if (!value || !educationLevels || !educationLevels.some(function (el) {
    return el.name === value;
  })) {
    validationResult = [false, ErrorMessages.SELECT_EDUCATION_LEVEL];
  }
  return validationResult;
};
export var isDegreeFieldValid = function isDegreeFieldValid(degree, educationLevel, levels) {
  var _GetDegreeOptionsByEd;
  var validationResult = [true, ''];
  if (!degree || !levels || !educationLevel || !(levels !== null && levels !== void 0 && levels.some(function (e) {
    return e.name === educationLevel;
  })) || !((_GetDegreeOptionsByEd = GetDegreeOptionsByEducationLevel(levels, educationLevel)) !== null && _GetDegreeOptionsByEd !== void 0 && _GetDegreeOptionsByEd.some(function (e) {
    return e.id === degree;
  }))) {
    validationResult = [false, ErrorMessages.SELECT_DEGREE];
  }
  return validationResult;
};
export var isEducationStatusFieldValid = function isEducationStatusFieldValid(educationStatus) {
  var validationResult = [true, ''];
  if (!educationStatus) {
    validationResult = [false, ErrorMessages.SELECT_OPTION];
  }
  return validationResult;
};
export var isMostRecentOverallGradeNotPopulated = function isMostRecentOverallGradeNotPopulated(value) {
  if (!value) {
    return true;
  }
  var gradingSchemeId = value.gradingSchemeId,
    grade = value.grade;
  if (gradingSchemeId === null) {
    return true;
  }
  if (grade === '') {
    return true;
  }
  return false;
};

//--

export var isValidStep = function isValidStep(score, step) {
  if (step === 1) return Number.isInteger(score);
  if (step === 0.1) {
    return /^\d*\.?\d?0*$/.test(score.toPrecision(12));
  }
  if (step === 0.5) {
    return /^\d*\.?5?0*$/.test(score.toPrecision(12));
  }
  return score % step === 0;
};
export var areExamScoresValid = function areExamScoresValid(scores, expectation) {
  var type = scores.value;
  var error = {
    invalid: new Set(),
    message: ''
  };
  var validationResult = [true, error];
  Object.keys(expectation).forEach(function (i) {
    var _scores$i;
    if (!(i in scores) || ((_scores$i = scores[i]) === null || _scores$i === void 0 ? void 0 : _scores$i.length) === 0 || Number(scores[i]) < expectation[i].min || Number(scores[i]) > expectation[i].max || !isValidStep(Number(scores[i]), expectation[i].step)) {
      error.invalid.add(i);
      if (type === 'toefl') error.message = ErrorMessages.TOEFL_SCORE;else if (type === 'ielts') error.message = ErrorMessages.IELTS_SCORE;else if (type === 'pte') error.message = ErrorMessages.PTE_SCORE;else if (type === 'duolingo_english') error.message = ErrorMessages.DUOLINGO_SCORE;
      validationResult[0] = false;
    }
  });
  return validationResult;
};
var rangeErrorMsg = function rangeErrorMsg(min, max) {
  return "".concat(ErrorMessages.VALID_SCORE, " ").concat(min, " and ").concat(max, ".");
};
export var areTestScoresValid = function areTestScoresValid(type, scores, expectation) {
  var common = {
    v: '',
    vp: '',
    q: '',
    qp: '',
    w: '',
    wp: ''
  };
  var gmatT = {
    t: '',
    tp: ''
  };
  var error = type === 'gmat' ? _objectSpread(_objectSpread({}, common), gmatT) : _objectSpread({}, common);
  var validationResult = [true, error];
  Object.keys(expectation).forEach(function (i) {
    var _scores$i2;
    if (!(i in scores) || ((_scores$i2 = scores[i]) === null || _scores$i2 === void 0 ? void 0 : _scores$i2.length) === 0 || isNaN(Number(scores[i])) || Number(scores[i]) < expectation[i].min || Number(scores[i]) > expectation[i].max || expectation[i].step && !isValidStep(Number(scores[i]), expectation[i].step) // check step if it exists
    ) {
      if (i.endsWith('p')) error[i] = ErrorMessages.PERCENTILE_RANKING;else error[i] = rangeErrorMsg(expectation[i].min, expectation[i].max);
      validationResult[0] = false;
    }
  });
  return validationResult;
};
function isGmatValid(value) {
  return areTestScoresValid('gmat', value, SCORE_LIMITS.gmat)[0];
}
function isGreValid(value) {
  return areTestScoresValid('gre', value, SCORE_LIMITS.gre)[0];
}
export var isQuestion8Valid = function isQuestion8Valid(standardizedTests, gmatTest, greTest) {
  return !!(standardizedTests !== null && standardizedTests !== void 0 && standardizedTests.dont_have || (standardizedTests !== null && standardizedTests !== void 0 && standardizedTests.gmat || standardizedTests !== null && standardizedTests !== void 0 && standardizedTests.gre) && (!(standardizedTests !== null && standardizedTests !== void 0 && standardizedTests.gmat) || isGmatValid(gmatTest)) && (!(standardizedTests !== null && standardizedTests !== void 0 && standardizedTests.gre) || isGreValid(greTest)));
};
export var isFromApplyBoostCountry = function isFromApplyBoostCountry(nationality, countryOfResidence, applyBoostCountriesByCode) {
  return applyBoostCountriesByCode.includes(nationality === null || nationality === void 0 ? void 0 : nationality.code) && applyBoostCountriesByCode.includes(countryOfResidence === null || countryOfResidence === void 0 ? void 0 : countryOfResidence.code);
};
export var isApplyBoostEligible = function isApplyBoostEligible(nationality, countryOfResidence, applyBoostCountriesByCode, applicationCompleteOnLoad, shouldAskForStandardizedTests) {
  var isStudentFromApplyBoostCountry = isFromApplyBoostCountry(nationality, countryOfResidence, applyBoostCountriesByCode);
  return isStudentFromApplyBoostCountry && (!applicationCompleteOnLoad || !!shouldAskForStandardizedTests);
};
export var validateEnglishProficiencyData = function validateEnglishProficiencyData(englishProficiencyTestData) {
  var validResponse = false;
  if ((englishProficiencyTestData === null || englishProficiencyTestData === void 0 ? void 0 : englishProficiencyTestData.value) === ENGLISH_EXAM_TYPE_VALUES.DONT_HAVE || (englishProficiencyTestData === null || englishProficiencyTestData === void 0 ? void 0 : englishProficiencyTestData.value) === ENGLISH_EXAM_TYPE_VALUES.PROVIDELATER) {
    validResponse = true;
  } else if (englishProficiencyTestData.value in SCORE_LIMITS_ENGLISH_TEST) {
    var expectation = SCORE_LIMITS_ENGLISH_TEST[englishProficiencyTestData.value];
    var validationResult = areExamScoresValid(englishProficiencyTestData, expectation);
    var _validationResult = _slicedToArray(validationResult, 1);
    validResponse = _validationResult[0];
  }
  return validResponse;
};